// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2123":"3a51ccc98f8806b1","2768":"e56018dbe2b6409e","7058":"e446adbf119ff5a7","8761":"da71f4db0438d5f7"}[chunkId] + ".js";
};